export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';
export const UPDATE_NETWORK_OFFLINE_MESSAGE = 'UPDATE_NETWORK_OFFLINE_MESSAGE';

export const NETWORK_STATUS_ONLINE = 'NETWORK_STATUS_ONLINE';
export const NETWORK_STATUS_OFFLINE = 'NETWORK_STATUS_OFFLINE';

export function updateNetworkStatus(status) {
    return {
        type: UPDATE_NETWORK_STATUS,
        payload: status,
    };
}

export const NETWORK_OFFLINE_DEFAULT_MESSAGE = {
    isVisible: false,
    targetUrl: null,
};

export function resetNetworkOfflineMessage() {
    return {
        type: UPDATE_NETWORK_OFFLINE_MESSAGE,
        payload: Object.assign({}, NETWORK_OFFLINE_DEFAULT_MESSAGE),
    };
}

export function updateNetworkOfflineMessage(isVisible, targetUrl) {
    return {
        type: UPDATE_NETWORK_OFFLINE_MESSAGE,
        payload: {
            isVisible,
            targetUrl,
        },
    };
}
